import "./style.css";
import { useState } from "react";
import TextField from "@mui/material/TextField";
import LoadingButton from "@mui/lab/LoadingButton";
import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import toast from "react-hot-toast";

export default function Form() {
  let [message, setMessage] = useState("");
  let [yourName, setYourName] = useState("");
  let [yourEmail, setYourEmail] = useState("");
  let [shouldSucceed, setShouldSucceed] = useState(true);
  let [errorCode, setErrorCode] = useState(null);
  let [loading, setLoading] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);

    // payload is a new constant of type object
    const payload = {
      message,
      yourName,
      yourEmail,
    };

    const resource = `https://httpbin.org/status/${
      shouldSucceed ? "200" : errorCode
    }`;

    fetch(resource, {
      method: "POST",
      body: JSON.stringify(payload),
    })
      .then((data) => {
        const statusString = data.status.toString();

        switch (statusString.charAt(0)) {
          case "4":
            throw "Client Error: " + errorMessageMapping[statusString];

          case "5":
            throw "Server Error: " + errorMessageMapping[statusString];
        }

        setMessage("");
        setYourName("");
        setYourEmail("");
        setErrorCode(null);
        setShouldSucceed(true);
        toast.success("Submitted!");
      })
      .catch((error) => {
        toast.error(`Failed to save data, ${error}`);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <form onSubmit={handleSubmit}>
      <h1 className="input half">Hire me</h1>
      <FormControlLabel
        className="input half checkbox"
        control={
          <Switch
            checked={shouldSucceed}
            disabled={loading}
            onChange={() => {
              setErrorCode(null);
              setShouldSucceed(!shouldSucceed);
            }}
          />
        }
        label="Should Succeed"
      />

      <TextField
        className="input full"
        label="Message"
        type="text"
        variant="outlined"
        margin="normal"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        disabled={loading}
        required
        fullWidth
        multiline
        rows={4}
      />
      <TextField
        className="input half"
        label="Your Name"
        type="name"
        variant="outlined"
        margin="normal"
        value={yourName}
        onChange={(e) => setYourName(e.target.value)}
        disabled={loading}
        fullWidth
        required
      />
      <TextField
        className="input half"
        label="Your Email"
        type="email"
        variant="outlined"
        value={yourEmail}
        onChange={(e) => setYourEmail(e.target.value)}
        margin="normal"
        disabled={loading}
        fullWidth
        required
      />

      {shouldSucceed ? null : (
        <FormControl className="input half" fullWidth margin="normal">
          <InputLabel id="error-code-label">Desired Error Code</InputLabel>
          <Select
            labelId="error-code-label"
            id="error-code"
            value={errorCode}
            label="Desired Error Code"
            disabled={loading}
            fullWidth
            onChange={(e) => setErrorCode(e.target.value)}
          >
            <MenuItem value={400}>400</MenuItem>
            <MenuItem value={401}>401</MenuItem>
            <MenuItem value={402}>402</MenuItem>
            <MenuItem value={403}>403</MenuItem>
            <MenuItem value={404}>404</MenuItem>
            <MenuItem value={500}>500</MenuItem>
            <MenuItem value={501}>501</MenuItem>
            <MenuItem value={502}>502</MenuItem>
            <MenuItem value={503}>503</MenuItem>
            <MenuItem value={504}>504</MenuItem>
          </Select>
        </FormControl>
      )}

      <FormControl className="input button" fullWidth margin="normal">
        <LoadingButton
          loading={loading}
          disabled={loading}
          className="input"
          variant="contained"
          type="submit"
          size="large"
        >
          Submit
        </LoadingButton>
      </FormControl>
    </form>
  );
}

const errorMessageMapping = {
  400: "Bad Request",
  401: "Unauthorized",
  402: "Payment Required",
  403: "Forbidden",
  404: "Not Found",
  500: "Internal Server Error",
  501: "Not Implemented",
  502: "Bad Gateway",
  503: "Service Unavailable",
  504: "Gateway Timeout",
};
